<template>
  <CRUDDialog ref="crudDialog" :baseCrudKey="dialogCrudKey"
  dialogDynamicWidth="40vw"
  dialogHeaderName="Personal Tax Warrants Information"
  :canSave="true"   @upsertItem="upsertTransaction">
    <template v-slot:[`editedItem`]="{ }">
      <template class="">
        <div class="input-text-size pa-0 ma-0 custom-red-text">{{ errorMessage }}</div>
        <div v-if="ownerName" class="input-text-size pa-0 ma-0">
  <span class="font-weight-bold">Owner Name:</span> {{ ownerName || 'N/A' }}
</div>
            <div class="scrollable-ctnr pb-0 ma-0">
            <div class="input-text-size pa-0 ma-0 ">
              By Confirming, you will create  {{ selectedItems.length  ||0 }}
              new records in the Personal Tax Warrants system
            </div>
            <div class="input-text-size pa-0 ma-0 font-weight-bold text-h6 primary--text">
              Your beginning warrant number will be {{ editedItem.warrantNumber }}
            </div>
            <div class="input-text-size pa-0 mb-6 ">
              To each record will be applied the following fees:
            </div>
            <v-row class="">
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class='input-text-size pa-0 ma-0 ' readonly
                  v-model="editedItem.sherifFee">
                  <template v-slot:label>
                    <label>Sheriff Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0 ">
                  <v-text-field class='input-text-size pa-0 ma-0 '
                  v-model.number="editedItem.sherifFeeAmount"
                  @blur="amountToNum('sherifFeeAmount')">
                  <template v-slot:label>
                    <label>Sheriff Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0' readonly
                  v-model="editedItem.treasureFee">
                  <template v-slot:label>
                    <label>Treasurer Fee</label>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols="6" class="pt-0 pb-0">
                  <v-text-field class=' input-text-size pa-0 ma-0'
                  v-model.number="editedItem.treasureFeeAmount"
                  @blur="amountToNum('treasureFeeAmount')">
                  <template v-slot:label>
                    <label>Treasurer Fee Amount</label>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          <v-row>
            <v-col cols='6' class="pt-0 pb-0 mt-n5">
                            <ClarionDateControl class="input-text-size"
                            :isToggle="false"
                            :isIsoDate="true"
                             v-model="editedItem.penaltyDate" label="Penalty Date" />
                        </v-col>
          </v-row>
          </div>

</template>

      </template>
  </CRUDDialog>

</template>

<script>
import {
  mapGetters, mapState, mapMutations, mapActions,
} from 'vuex';
import CRUDDialog from '../../../common/base/crud-2.0/CRUDDialog.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { toIsoDate } from '../../../../util/shared/tmc-global';
import { TaxWarrantsDialogMixin } from '../../warrants/utils/taxWarrants.mixin';
import {
  formatWarrantNumber,
  warrantAmountUtils,
} from '../../warrants/utils/taxWarrants.util';

export default {
  name: 'TaxWarrantsCreateDialogTRWork',
  mixins: [TaxWarrantsDialogMixin],
  components: {
    CRUDDialog,
    ClarionDateControl,
  },
  props: {
    baseCrudKey: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    dialogCrudKey: 'personalTaxWarrantCreate',
    errorMessage: null,
  }),
  created() {
    this.loadConfig({ requiredScope: 'taxConfig' });
  },
  computed: {
    ...mapGetters('base/crud', ['item', 'isVisible']),
    ...mapState({
      nextWarrantNumber: (state) => state.tax.taxWarrants.nextWarrantNumber,
      nextWarrantSystemID: (state) => state.tax.taxWarrants.nextWarrantSystemID,
      StoreSelItems: (state) => state.tax.trWorkFile.selectedItems,
    }),

    editedItem: {
      get() {
        return this.item(this.dialogCrudKey);
      },
      set(value) {
        this.setItem([this.dialogCrudKey, value]);
      },
    },
    ownerName() {
      if (this.selectedItems.length) {
        return `${(this.selectedItems || [])[0].name1 || ''}  ${(this.selectedItems || [])[0].name2 || ''}`;
      }
      return '';
    },
    visibility() {
      return this.isVisible(this.dialogCrudKey);
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
    },
  },
  watch: {
    visibility: {
      handler(visible) {
        if (visible && this.nextWarrantNumber !== null) {
          this.applyBeginningWarrantNumber(this.nextWarrantNumber);
          this.editedItem.systemId = this.nextWarrantSystemID;
        }
      },
      immediate: true,
    },
    nextWarrantNumber(newValue) {
      if (this.visibility && newValue !== null) {
        this.applyBeginningWarrantNumber(newValue);
      }
    },
    // loadConfig() is async, so the current tax year can land after the dialog is already
    // open - fill in the beginning number that was held back when it did.
    currentWarrantTaxYear() {
      if (this.visibility && this.nextWarrantNumber !== null) {
        this.applyBeginningWarrantNumber(this.nextWarrantNumber);
      }
    },
  },
  methods: {
    ...mapMutations('base/crud', ['setItem']),
    ...mapActions(['flashError']),
    ...mapActions('tax/taxWarrants', [
      'upsertBulkTaxWarrant',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig',
    ]),

    formatWarrantNumber(taxYear, warrantNumber) {
      return formatWarrantNumber(taxYear, warrantNumber);
    },

    // One place that builds the beginning number, so the prefix cannot drift between the
    // value previewed in the dialog and the one actually written at submit time.
    applyBeginningWarrantNumber(sequence) {
      if (!(this.selectedItems || []).length) return false;
      if (!this.currentWarrantTaxYear) return false;
      this.editedItem.warrantNumber = this.formatWarrantNumber(
        this.currentWarrantTaxYear, sequence,
      );
      return true;
    },

    preProcessForUpsert(item) {
      const taxInquiryItems = [];
      this.selectedItems.forEach((record, index) => {
        taxInquiryItems.push({
          taxYear: record.taxYear,
          taxId: record.taxId,
          baseId: record.baseId,
          warrantNumber: this.editedItem.warrantNumber + index,
          sherifFee: item.sherifFee,
          treasureFee: item.treasureFee,
          sherifFeeAmount: warrantAmountUtils.toNumber(item.sherifFeeAmount),
          treasureFeeAmount: warrantAmountUtils.toNumber(item.treasureFeeAmount),
          taxInquiryTransaction: record.taxInquiryTransaction,
          systemId: (warrantAmountUtils.toNumber(this.editedItem.systemId) + index),
          aliasNumber: 1,
          issueDate: toIsoDate(new Date()),
          penaltyDate: (this.editedItem.penaltyDate),
          totalDue: record.totalDue,
          totalFee: record.totalFee,
          totalTax: record.totalTax,
          propertyOrParcelId: record.propertyOrParcelId,
        });
      });
      return taxInquiryItems;
    },

    // The beginning number shown in the dialog was fetched when the dialog opened. A list
    // action run in pages - or a second clerk - can have consumed that number in the
    // meantime (Tulsa 9/15/2026: page 2 was submitted a minute after page 1 and reused all
    // 26 of its numbers). Re-read it here, at submit time, so the batch is numbered from
    // whatever is actually free rather than from a stale snapshot.
    async refreshStartingNumbers() {
      const [maxWarrantNo, maxSystemId] = await Promise.all([
        this.loadLastWarrantNo(),
        this.loadLastSystemID(),
      ]);
      // Both actions swallow their failure and return {} - numbering off a value we could
      // not confirm is exactly what created the duplicates, so refuse to submit instead.
      if (!Number.isFinite(maxWarrantNo) || !Number.isFinite(maxSystemId)) {
        return false;
      }
      if (!this.applyBeginningWarrantNumber(maxWarrantNo + 1)) return false;
      this.editedItem.systemId = maxSystemId + 1;
      return true;
    },

    async upsertTransaction(item) {
      // CRUDDialog closes as soon as it emits upsertItem, so these have to be flash
      // messages - the dialog's own errorMessage line is gone by the time one would show.
      if (!this.currentWarrantTaxYear) {
        this.flashError('Could not determine the current tax year for the warrant number - nothing was saved. Please check Tax Settings and try again.');
        return;
      }
      if (!await this.refreshStartingNumbers()) {
        this.flashError('Could not confirm the next free warrant number - nothing was saved. Please try again.');
        return;
      }
      const updatedItem = this.preProcessForUpsert(item);
      await this.upsertBulkTaxWarrant({ item: updatedItem, baseCrudKey: this.dialogCrudKey });
    },

  },
};
</script>

<style scoped>
.custom-red-text {
  color: red;
  font-weight: bold;
}
</style>
